import styled from 'styled-components';

import Button from 'web-components/Button';
import { Flex } from 'web-styled';

export const Header = styled(Flex).attrs({
  width: '100%',
  justify: 'space-between',
})`
  padding: 25px;
  margin: -25px;
  width: calc(100% + 50px);
  background: #F7F7F7;
`;

export const SubHeader = styled(Flex).attrs({
  width: '100%',
  align: 'center',
  justify: 'space-between',
})`
  padding: 0 0 24px 0;
  border-bottom: 0.5px solid #c7c7cb;
`;

export const Notes = styled.div`
  position: absolute;
  top: 0;
  right: -390px;
  width: 350px;
  min-height: 350px;
  background: #fff;
`;

export const NoteToggle = styled(Flex).attrs<{ open?: boolean }>({
  align: 'center',
  spacing: 8,
})`
  color: ${props => props.theme.colors.primary};
  font-size: 17px;
  svg {
    border: 1px solid ${props => props.theme.colors.primary};
    border-radius: 50%;
    padding: 3px;
    margin-left: 5px;
    path {
      stroke: ${props => props.theme.colors.primary};
    }
  }

  opacity: ${props => (props.disabled ? 0.3 : 1)};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
`;


export const NoteHeader = styled(Flex).attrs<{ isError?: boolean }>({
  align: 'center',
  justify: 'space-between',
  spacing: 8,
})`
  color: #fff;
  font-size: 18px;
  width: 100%;
  padding: 15px 25px;
  border-bottom: 1px solid #e5e5e5;
  background: ${props => (props.isError ? props.theme.colors.darkDanger : props.theme.colors.modalHeader)};
`;

export const NotesBody = styled.div`
  padding: 20px;
  max-height: 390px;
  overflow-x: auto;
`;

export const Close = styled(Button).attrs({
  appearance: 'link',
})`
  color: #fff;
  font-size: 13px;
  font-weight: normal;
  text-shadow: none;
  opacity: 0.5;
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;

  &:hover {
    color: #fff;
    text-decoration: none;
    opacity: 0.9;
  }
`;
